export const BUSINESS_TYPES = [
  { name: 'Partnership', value: 'Partnership' },
  { name: 'Corporation', value: 'Corporation' },
  { name: 'Co-operative', value: 'Co-operative' },
  { name: 'Limited Liability Corperation', value: 'Limited Liability Corporation' },
  { name: 'Non-profit Corperation', value: 'Non-profit Corporation' },
];

export const BUSINESS_ID_TYPES = [
  { name: 'USA: Employer Identification Number (EIN)', value: 'EIN' },
  { name: 'Canada: Canadian Business Number (CBN)', value: 'CBN' },
  { name: 'Great Britain: Company Number', value: 'CN' },
  { name: 'Australia: Company Number from ASIC (ACN)', value: 'ACN' },
  { name: 'India: Corperate Identity Number', value: 'CIN' },
  { name: 'VAT Number', value: 'VAT' },
  { name: 'Israel: Registration Number', value: 'RN' },
  { name: 'Other', value: 'Other' },
];

export const REGIONS = [
  { name: 'Africa', value: 'AFRICA' },
  { name: 'Asia', value: 'ASIA' },
  { name: 'Europe', value: 'EUROPE' },
  { name: 'Latin America', value: 'LATIN_AMERICA' },
  { name: 'USA and Canada', value: 'USA_AND_CANADA' },
];

export const INDUSTRIES = [
  { name: 'AUTOMOTIVE', value: 'AUTOMOTIVE' },
  { name: 'AGRICULTURE', value: 'AGRICULTURE' },
  { name: 'BANKING', value: 'BANKING' },
  { name: 'CONSTRUCTION', value: 'CONSTRUCTION' },
  { name: 'CONSUMER', value: 'CONSUMER' },
  { name: 'EDUCATION', value: 'EDUCATION' },
  { name: 'ENGINEERING', value: 'ENGINEERING' },
  { name: 'ENERGY', value: 'ENERGY' },
  { name: 'OIL AND GAS', value: 'OIL_AND_GAS' },
  { name: 'FAST MOVING CONSUMER GOODS', value: 'FAST_MOVING_CONSUMER_GOODS' },
  { name: 'FINANCIAL', value: 'FINANCIAL' },
  { name: 'FINTECH', value: 'FINTECH' },
  { name: 'FOOD AND BEVERAGE', value: 'FOOD_AND_BEVERAGE' },
  { name: 'GOVERNMENT', value: 'GOVERNMENT' },
  { name: 'HEALTHCARE', value: 'HEALTHCARE' },
  { name: 'HOSPITALITY', value: 'HOSPITALITY' },
  { name: 'INSURANCE', value: 'INSURANCE' },
  { name: 'LEGAL', value: 'LEGAL' },
  { name: 'MANUFACTURING', value: 'MANUFACTURING' },
  { name: 'MEDIA', value: 'MEDIA' },
  { name: 'ONLINE', value: 'ONLINE' },
  { name: 'PROFESSIONAL SERVICES', value: 'PROFESSIONAL_SERVICES' },
  { name: 'RAW MATERIALS', value: 'RAW_MATERIALS' },
  { name: 'REAL ESTATE', value: 'REAL_ESTATE' },
  { name: 'RELIGION', value: 'RELIGION' },
  { name: 'RETAIL', value: 'RETAIL' },
  { name: 'JEWELRY', value: 'JEWELRY' },
  { name: 'TECHNOLOGY', value: 'TECHNOLOGY' },
  { name: 'TELECOMMUNICATIONS', value: 'TELECOMMUNICATIONS' },
  { name: 'TRANSPORTATION', value: 'TRANSPORTATION' },
  { name: 'TRAVEL', value: 'TRAVEL' },
  { name: 'ELECTRONICS', value: 'ELECTRONICS' },
  { name: 'NOT FOR PROFIT', value: 'NOT_FOR_PROFIT' },
];

export const COUNTRIES = [
  { value: 'AF', name: 'Afghanistan' },
  { value: 'AL', name: 'Albania' },
  { value: 'DZ', name: 'Algeria' },
  { value: 'AD', name: 'Andorra' },
  { value: 'AO', name: 'Angola' },
  { value: 'AI', name: 'Anguilla' },
];

export const JOB_POSITIONS = [
  { name: 'Director', value: 'Director' },
  { name: 'GM', value: 'GM' },
  { name: 'VP', value: 'Director' },
  { name: 'CEO', value: 'CEO' },
  { name: 'CFO', value: 'CFO' },
  { name: 'General Counsel', value: 'General Counsel' },
  { name: 'Other', value: 'Other' },
];
